import { createFileRoute, redirect } from '@tanstack/react-router'
import { InvoiceDetailScreen } from '@/features/accounting-invoices/invoice-detail-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for one invoice or credit note.
 *
 * The grant guard is `accounting_invoice.view`, the same key as the list.
 * Whether the caller may see THIS document is the API's answer, not the
 * browser's: tenancy scoping makes another company's invoice a 404, and the
 * screen surfaces that rather than deciding it here.
 */
export const Route = createFileRoute('/_authenticated/accounting/invoices/$invoiceId/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_invoice.view')) {
      throw redirect({ to: '/accounting/invoices' })
    }
  },
  component: AccountingInvoiceDetailRoute,
})

function AccountingInvoiceDetailRoute() {
  const { invoiceId } = Route.useParams()

  return <InvoiceDetailScreen invoiceId={invoiceId} />
}
